import React from 'react';
import styled from 'styled-components';

interface ITextViewWidget {
  label: string;
  value?: any;
}

const TextViewWidgetContainer = styled.div`
  color: ${({ theme }) => theme.colors.Tarpon};
  font-size: ${({ theme }) => theme.fontSize.s};
`;
const TextViewWidgetLabel = styled.span`
  font-weight: bold;
`;
const TextViewWidgetValue = styled.span`
  padding-left: 1rem;
  font-weight: normal;
  white-space: pre-wrap;
  word-break: break-word;
  flex: 1;
`;

const TextViewWidget: React.FC<ITextViewWidget> = ({ label, value }) => {
  if (value instanceof Array) {
    value = value.join(', ');
  }
  return (
    <TextViewWidgetContainer>
      <TextViewWidgetLabel>{label}: </TextViewWidgetLabel>
      <TextViewWidgetValue>{value}</TextViewWidgetValue>
    </TextViewWidgetContainer>
  );
};

export { TextViewWidget };
